'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookLoma = require('@narvar/nth-hook-loma');
var SessionContext = require('../providers/SessionContext.js');
var TrackingStatusText = require('./TrackingStatusText.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ShipmentName = _ref => {
  let {
    edd,
    status,
    statusCode
  } = _ref;
  const {
    retailerMoniker,
    versionName,
    localeCountry,
    localeLanguage
  } = SessionContext.useSession();
  const {
    data
  } = nthHookLoma.useFormatShipmentEddQuery({
    skip: !(edd !== null && edd !== void 0 && edd.begin),
    variables: {
      retailerMoniker,
      versionName,
      localeLanguage,
      localeCountry,
      eddCombos: [{
        displayDate: (edd === null || edd === void 0 ? void 0 : edd.begin) ?? '',
        eddFormatTranslationKeys: [{
          lastDay: 'claimsShipmentEddLastDayDateFormat',
          lastWeek: 'claimsShipmentEddLastWeekDateFormat',
          nextDay: 'claimsShipmentEddNextDayDateFormat',
          nextWeek: 'claimsShipmentEddNextWeekDateFormat',
          sameDay: 'claimsShipmentEddSameDayDateFormat',
          sameElse: 'claimsShipmentEddSameElseDateFormat'
        }],
        dateOnly: false
      }]
    }
  });
  const displayDate = data === null || data === void 0 ? void 0 : data.formatEdd.formattedEdds[0];
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(TrackingStatusText["default"], {
    status: status ?? undefined,
    statusCode: statusCode ?? undefined
  }), ` `, displayDate);
};

exports["default"] = ShipmentName;
